import { useState, useEffect } from "react";
import { personalInfo } from "../data/index";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { label: "About", href: "#about" },
    { label: "Skills", href: "#skills" },
    { label: "Projects", href: "#projects" },
    { label: "Experience", href: "#experience" },
    { label: "Contact", href: "#contact" },
  ];

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 50);
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        height: "70px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 40px",
        background: scrolled ? "rgba(26,26,26,0.95)" : "transparent",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        borderBottom: scrolled ? "1px solid #2e2e2e" : "none",
        transition: "all 0.3s ease",
      }}
    >
      <a
        href="#hero"
        style={{
          fontSize: "1.4rem",
          fontWeight: 800,
          color: "#f5f5f5",
          textDecoration: "none",
        }}
      >
        Ludwig<span style={{ color: "#22d3ee" }}>.</span>
      </a>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "32px",
        }}
      >
        {links.map((item) => (
          <a
            key={item.label}
            href={item.href}
            style={{
              color: "#a0a0a0",
              fontSize: "0.9rem",
              fontWeight: 500,
              textDecoration: "none",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.color = "#22d3ee";
            }}
            onMouseLeave={(e) => {
              e.target.style.color = "#a0a0a0";
            }}
          >
            {item.label}
          </a>
        ))}

        <a
          href={personalInfo.cv}
          target="_blank"
          rel="noreferrer"
          style={{
            background: "#22d3ee",
            color: "#1a1a1a",
            padding: "10px 20px",
            borderRadius: "10px",
            fontSize: "0.85rem",
            fontWeight: 700,
            textDecoration: "none",
          }}
        >
          Download CV ↓
        </a>
      </div>

      <button
        onClick={() => setMenuOpen(!menuOpen)}
        style={{
          display: "none",
          background: "none",
          border: "none",
          cursor: "pointer",
          flexDirection: "column",
          gap: "5px",
          padding: "8px",
        }}
        className="nav-hamburger"
      >
        <span
          style={{
            display: "block",
            width: "24px",
            height: "2px",
            background: "#f5f5f5",
            borderRadius: "2px",
          }}
        />
        <span
          style={{
            display: "block",
            width: "24px",
            height: "2px",
            background: "#f5f5f5",
            borderRadius: "2px",
          }}
        />
        <span
          style={{
            display: "block",
            width: "24px",
            height: "2px",
            background: "#f5f5f5",
            borderRadius: "2px",
          }}
        />
      </button>

      {menuOpen && (
        <div
          style={{
            position: "absolute",
            top: "70px",
            left: 0,
            right: 0,
            background: "rgba(26,26,26,0.98)",
            backdropFilter: "blur(12px)",
            borderBottom: "1px solid #2e2e2e",
            padding: "24px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {links.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setMenuOpen(false)}
              style={{
                color: "#a0a0a0",
                fontSize: "1rem",
                textDecoration: "none",
                padding: "8px 0",
                borderBottom: "1px solid #2e2e2e",
              }}
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
